import { lazyImport } from "@src/utility/lazyImport";
import { Navigate } from "react-router-dom";

const { Tournaments } = lazyImport(
  () => import("@features/newTournament"),
  "Tournaments"
);

const { CreateTournament } = lazyImport(
  () => import("@features/newTournament"),
  "CreateTournament"
);

const { TournamentReport } = lazyImport(
  () => import("@features/newTournament"),
  "TournamentReport"
);

const { TournamentDashboard } = lazyImport(
  () => import("@features/newTournament"),
  "TournamentDashboard"
);

const { ChooseOfficials } = lazyImport(
  () => import("@features/newTournament"),
  "ChooseOfficials"
);

const { PrizesAndClubInfo } = lazyImport(
  () => import("@features/newTournament"),
  "PrizesAndClubInfo"
);

const { TournamentDetails } = lazyImport(
  () => import("@features/newTournament"),
  "TournamentDetails"
);

const { TournamentTransactions } = lazyImport(
  () => import("@features/newTournament"),
  "TournamentTransactions"
);

const { TournamentPlayersList } = lazyImport(
  () => import("@features/tournamentPlayer"),
  "TournamentPlayersList"
);

const { TournamentPlayerDetails } = lazyImport(
  () => import("@features/tournamentPlayer"),
  "TournamentPlayerDetails"
);

const { RolesInfo } = lazyImport(
  () => import("@features/newTournament"),
  "RolesInfo"
);

const { ResultInfo } = lazyImport(
  () => import("@features/newTournament"),
  "ResultInfo"
);

const { TournamentMatchDetails } = lazyImport(
  () => import("@features/newTournament"),
  "TournamentMatchDetails"
);

// const { CreateTournament } = lazyImport(
//   () => import("../../features/tournament"),
//   "CreateTournament"
// );

const { TournamentCreated } = lazyImport(
  () => import("../../features/tournament"),
  "TournamentCreated"
);

const { UpdateTournament } = lazyImport(
  () => import("../../features/tournament"),
  "UpdateTournament"
);

const { Pairing } = lazyImport(
  () => import("../../features/pairing"),
  "Pairing"
);

const { MatchDetails } = lazyImport(
  () => import("../../features/match"),
  "MatchDetails"
);

const { PublicTournaments } = lazyImport(
    () => import("@features/newTournament"),
    "PublicTournaments"
);

const { Tournament } = lazyImport(
    () => import("@features/newTournament"),
    "Tournament"
);

const { TournamentRules } = lazyImport(
    () => import("@features/newTournament"),
    "TournamentRules"
);

const { TournamentParticipants } = lazyImport(
    () => import("@features/newTournament"),
    "TournamentParticipants"
);

const { TournamentRankingList } = lazyImport(
    () => import("@features/newTournament"),
    "TournamentRankingList"
);

const TournamentRoutes = [
  {
    path: "/dashboard/tournaments",
    element: <Tournaments />,
  },
  {
    path: "/dashboard/tournaments/:id/report",
    element: <TournamentReport />,
    children: [
      {
        path: "transactions",
        element: <TournamentTransactions />,
      },
      {
        path: "players",
        element: <TournamentPlayersList />,
      },
      {
        path: "result",
        element: <ResultInfo />,
        children: [
          {
            path: "match/:matchId",
            element: <TournamentMatchDetails />,
          },
        ],
      },
      {
        path: "players/:playerId",
        element: <TournamentPlayerDetails />,
      },
      {
        path: "*",
        element: <Navigate to={"transactions"} />,
      },
    ],
  },
  {
    path: "/dashboard/tournaments/:id/",
    element: <TournamentDashboard />,
    children: [
      {
        path: "prizes",
        element: <PrizesAndClubInfo />,
      },
      {
        path: "details",
        element: <TournamentDetails />,
      },
      {
        path: "roles",
        element: <RolesInfo />,
      },
      {
        path: "result",
        element: <ResultInfo />,
        children: [
          {
            path: "match/:matchId",
            element: <TournamentMatchDetails />,
          },
        ],
      },
      {
        path: "*",
        element: <Navigate to={"details"} />,
      },
      {
        path: "",
        element: <Navigate to={"details"} />,
      },
    ],
  },
  {
    path: "/dashboard/tournaments/:id/choose-officials",
    element: <ChooseOfficials />,
  },
  {
    path: "/tournaments",
    element: <PublicTournaments />,
    meta: {
      publicRoute: true,
      menuHidden: true,
      layout: "blank",
    },
  },
  {
    path: "/tournaments/:id",
    element: <Tournament />,
    children: [
      {
        path: "rules", // Nested route for transactions tab
        element: <TournamentRules />,
      },
      {
        path: "participants", // Nested route for players tab
        element: <TournamentParticipants />,
      },
      {
        path: "ranking", // Nested route for player tab
        element: <TournamentRankingList />,
      },
      {
        path: "*",
        element: <Navigate to={'rules'} />,
      },
      // {
      //   path: "",
      //   element: <Navigate to={'rules'} />,
      // },
    ],
    meta: {
      publicRoute: true,
      menuHidden: true,
      layout: "blank",
    },
  },

  // {
  //   path: "/tournaments/:id",
  //   element: <Tournament />,
  //   meta: {
  //     action: "read",
  //     resource: "tournament",
  //   },
  // },
  {
    path: "/tournaments/:id/pairing",
    element: <Pairing />,
    meta: {
      action: "read",
      resource: "pairing",
    },
  },
  {
    path: "/tournaments/:id/match/:matchId",
    element: <MatchDetails />,
    meta: {
      action: "read",
      resource: "match_details",
    },
  },
  {
    path: "/dashboard/tournaments/create",
    element: <CreateTournament />,
    meta: {
      action: "create",
      resource: "tournament",
    },
  },
  {
    path: "/create-tournament/success",
    element: <TournamentCreated />,
    meta: {
      action: "create",
      resource: "tournament",
    },
  },
  {
    path: "/update-tournament/:id",
    element: <UpdateTournament />,
    meta: {
      action: "update",
      resource: "tournament",
    },
  },
];

export default TournamentRoutes;
